import React from 'react'
import { Link } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import duck from "../assets/duck-images/new-banner-removebg-preview.png"

import img1 from "../assets/slide-1.jpeg"
import img2 from "../assets/slide-2.jpeg"
import img3 from "../assets/slide-3.jpeg"
import img4 from "../assets/slide-4.jpeg"
import img5 from "../assets/slide-5.jpeg"
import img6 from "../assets/slide-6.jpeg"
import img7 from "../assets/slide-7.jpeg"
import img8 from "../assets/slide-8.jpeg"
import img9 from "../assets/slide-9.jpeg"
import img10 from "../assets/slide-10.jpeg"

import { ReactComponent as Shape_1 } from '../assets/duck-images/shape-01.svg';
import { ReactComponent as Shape_2 } from '../assets/duck-images/shape-02.svg';

// import frame from "../assets/duck-images/frame2Copy2.webp"
// import { motion, useViewportScroll, useTransform } from "framer-motion";


function Homepage({ ConnectWalletFunc, state, setState, disconnectWallet }) {
    // const { scrollYProgress } = useViewportScroll();
    // const scale = useTransform(scrollYProgress, [0, 1], [1, 2]);

    const isMobile = useMediaQuery({ query: '(max-width: 767px)' })


    return (
        <>

            {/* S E C T I O N - O N E  */}
            <section className='section-one'>
                <div className="glass">
                    <Navbar ConnectWalletFunc={ConnectWalletFunc} isConnect={state} setIsConnect={setState} disconnectWallet={disconnectWallet} />
                </div>

                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="content">
                                <h1> Duck </h1>
                                <h1> Duck </h1>
                                <div className="heading_1">
                                    <h1> Goose </h1>
                                </div>
                                {/* <motion.h1 style={{ scale }} > Duck </motion.h1>
                                <motion.h1 style={{ scale }} > Duck </motion.h1>
                                <div className="heading_1">
                                    <motion.h1 style={{ scale }} > Goose </motion.h1>
                                </div> */}
                            </div>
                        </div>
                        <div className={`col-lg-6 col-md-6 col-sm-12 col-12 banner_image ${isMobile ? "d-none" : "d-block"}`}>
                            <div className="content text-center">
                                <img src={duck} alt="img" className='img-fluid' style={{ maxHeight: "500px" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* S E C T I O N - E X T R A  */}
            <section className="extra">
                <div className="container">
                    <div className="row m-auto justify-content-center">
                        <div className="content-one">
                            <h1>WHAT IS DUCK DUCK GOOSE ALL ABOUT?</h1>
                            <p>Duck Duck Goose is a community driven brand. Our purpose is to delight the global community of pals that love our adorable art, believe in being kind to others, and come together to create the special, friendly atmosphere that is our online and offline community.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* S E C T I O N - T W O  */}
            <div className=''>
                <Shape_1 fill='#01af80' className='img-fluid shap_1' />
            </div>
            <section className='section-two'>
                <div className="row mx-auto p-0">
                    {/* <CenterMode /> */}
                    <div className="Marquee">
                        <div className="Marquee-content">
                            <div className="Marquee-tag">
                                <img src={img1} alt="img1" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img2} alt="img2" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img3} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img4} alt="img4" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img5} alt="img1" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img6} alt="img6" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img7} alt="img4" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img8} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img9} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img10} alt="img7" className='img-fluid' />
                            </div>

                            <div className="Marquee-tag">
                                <img src={img1} alt="img1" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img2} alt="img2" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img3} alt="img3" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img4} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img5} alt="img5" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img6} alt="img6" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img7} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img8} alt="img7" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img9} alt="img3" className='img-fluid' />
                            </div>
                            <div className="Marquee-tag">
                                <img src={img10} alt="img7" className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='sec_two_img'>
                <Shape_2 fill='#0063aa' className='img-fluid shap_2' />
            </div>


            {/* S E C T I O N - T H R E E */}
            {/* <div className="container">
                <section className='section-three' id='about'>
                    <div className="frame">
                        <img src={frame} alt="" className='img-fluid' />
                    </div>
                    <div className="container">
                        <div className="row justify-content-center align-items-center text-center">
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="content-brand">
                                    <h1 className='mb-4'>ABOUT OUR BRAND</h1>
                                    <p>What started out as a cute art collection, WonderPals has grown to one of the most recognizable cute brands within Web3. WonderPals is about having fun, enjoying cute art, and building community by creating lifelong pals!</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <img src={duck} alt="about" className='img-fluid about_duck_img' style={{ maxWidth: "350px" }} />
                            </div>
                        </div>
                    </div>
                </section>
            </div> */}


            {/* S E C T I O N - F A Q */}
            <section className='section-faq'>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="content">
                            <h1>Find out more on our Whitepaper</h1>
                        </div>
                    </div>
                    <div className='section-four' id='community'>
                        <div className="content-two" style={{ maxWidth: "100%" }}>
                            <div className="button mb-3 d-flex justify-content-center">
                                <a href="https://whitepaper.duckduckgoosegame.xyz/" target='_blank' className='btn mx-1 my-1'>
                                    <div>Whitepaper</div>
                                    <div className='button-bg'></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* S E C T I O N - F O U R  */}
            <section className='section-four' id='community'>
                <div className="container">
                    {/* <div className="borderr"></div> */}
                    <div className="row justify-content-center">
                        <div className="content-one">
                            <h1 className='text-center'>COMMUNITY</h1>
                            <p className='text-justify'>Duck Duck Goose is a community driven brand. Our purpose is to delight the global community of pals that love our adorable art, believe in being kind to others, and come together to create the special, friendly atmosphere that is our online and offline community.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="content-two">
                            <div className="button mb-5 d-flex justify-content-center">
                                <Link to='https://twitter.com/duck_goose_game' target='_blank' className='btn mx-1 my-1'>
                                    <div>Twitter</div>
                                    <div className='button-bg'></div>
                                </Link>
                                <Link to='https://t.me/duckduckgoosegame' target='_blank' className='btn mx-1 my-1'>
                                    <div>Telegram</div>
                                    <div className='button-bg2'></div>
                                </Link>
                            </div>
                            <small className='text-justify'>Come join us in Twitter - there will always be someone there to make you feel welcome!</small>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

        </>
    )
}

export default Homepage
